import { currentUserStorageKey, pbCollections } from "../../Consts/Consts";
import { UsersResponse } from "../../pocketbase-types";
import { ResetPassword } from "../../Types/UserTypes";
import { pbClient } from "./pb";


export const createUser = async (email: string) => {
    // you can also fetch all records at once via getFullList
    // const records = await pbClient.collection(pbCollections.roles).getFullList({
    //     sort: '-created',
    // });
    const password = generateSimplePassword(10)
    console.log(password);
    // const hashedPassword = await hashString(password)
    const user = await pbClient.collection(pbCollections.users).create({
        email: email,
        username: email.split('@')[0],
        password: password,
        passwordConfirm: password,
    })
    pbClient.collection('users').requestPasswordReset(email)
    return user
}

// async function hashString(input) {
//     const encoder = new TextEncoder();
//     const data = encoder.encode(input);
//     const hashBuffer = await crypto.subtle.digest('SHA-256', data);

//     // Convert buffer to hexadecimal string
//     let hashArray = Array.from(new Uint8Array(hashBuffer));
//     const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

//     return hashHex;
// }

function generateSimplePassword(length) {
    var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+<>?";
    var password = "";
    for (var i = 0; i < length; i++) {
        password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
}

export const login = async (email: string, password: string) => {
    const loged = await pbClient.collection(pbCollections.users).authWithPassword(email, password)
    const filter = loged.record.roles?.map?.(r => `id= '${r}'`).join('||')
    const roles = await pbClient.collection(pbCollections.roles).getList(1, 10, { filter })
    loged.record.expand = { roles: roles.items }
    return loged.record as UsersResponse
}

export const resetPassword = async ({ oldPassword, newPassword, confirmNewPassword, userId }: ResetPassword & { userId: string }) => {
    const d = await pbClient.collection(pbCollections.users).update(userId, { oldPassword, newPassword, confirmNewPassword })
    console.log("reset", d);
    pbClient.authStore.clear()
}

export const logout = () => {
    localStorage.removeItem(currentUserStorageKey)
    pbClient.authStore.clear()
}
export const requestPasswordReset = (email: string) => pbClient.collection('users').requestPasswordReset(email)